import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

const buildFilterString = ({ company }) => {
    const filterArray = [];

    // Active Only
    const activeFilter = 'NOT status:Inactive';
    filterArray.push(activeFilter);

    // Primary Business Type
    if (company.primaryBusinessType) {
        filterArray.push(`business_type:'${company.primaryBusinessType.name}'`);
    }

    // Secondary Business Type
    if (company.secondaryBusinessTypes?.length) {
        const secondaryFiltersString = company.secondaryBusinessTypes
            .map(type => `business_type:'${company.primaryBusinessType.name} > ${type.name}'`)
            .join(' OR ');
        filterArray.push(secondaryFiltersString);
    }

    // Not the Company itself
    const companyFilter = company.recordId ? `NOT objectID:company-${company.recordId}` : '';
    if (companyFilter) filterArray.push(companyFilter);

    const filterStr = filterArray.filter(f => f).join(' AND ');
    return filterStr;
};

const useCompaniesSimilarToFilterString = ({ company, additionalFilters }) => {
    const [filterString, setFilterString] = useState();

    useEffect(() => {
        if (!company) {
            return;
        }

        const str = buildFilterString({ company });
        setFilterString(str + (additionalFilters ? ` AND ${additionalFilters}` : ''));
    }, [additionalFilters, company, filterString]);

    return { filterString };
};

useCompaniesSimilarToFilterString.propTypes = {
    company: PropTypes.object,
    additionalFilters: PropTypes.string,
};

export default useCompaniesSimilarToFilterString;
